<script setup lang="ts">
import { useSearchStore } from "@/stores/search";
import { computed, nextTick, onMounted, ref } from "vue";
import { t } from "@/services/i18n";

const store = useSearchStore();
const emit = defineEmits(["next", "onInput"]);
const quickInput = ref<HTMLElement>();
const currentSearchTerm = computed(() => {
    return store.getQuickSearchValue;
});

async function updateValue(event: Event) {
    const currentValue = (event.target as HTMLInputElement).value;
    store.cacheSearchTerm(currentValue);
}

onMounted(() => {
    nextTick(() => {
        setTimeout(() => {
            quickInput.value?.focus();
        }, 100);
    });
});
</script>
<template>
    <div class="[ c-accordion__input ]">
        <input
            ref="quickInput"
            type="text"
            :value="currentSearchTerm"
            :placeholder="t('anywhere')"
            @input="updateValue($event)"
            @keydown.enter="emit('next')"
            @keydown.tab="emit('next')"
        />
    </div>
</template>
